import { applyComponentTheme } from '../../../theme';
import { PageNumberButton } from './styles';

export default applyComponentTheme(PageNumberButton, 'PageNumber');
